import "./ResiliencePlan.scss";
import plans from "../../../assets/images/resilienceplanimg.png";
import { NavLink } from "react-router-dom";
import downloadPdf from "../../../assets/pdfs/Lagos Climate Adaptation and Resilience Plan.pdf";
import wasteWaterPdf from "../../../assets/pdfs/LCARP Targeted wastewater treatment to prevent flood-contaminated drinking water.pdf";
import wasteToEnergyPdf from "../../../assets/pdfs/LCARP Flood prevention and clean energy via waste collection and incineration.pdf";
const ResiliencePlan = () => {
  return (
    <section className="resilience-plan">
      <div className="container">
        <div className="title">
          Lagos State Climate Adaptation and <span>Resilience Plan</span>
        </div>
        <div className="content">
          <div className="plan-content">
            <img src={plans} alt="plan" className="plan-img" />
            <a href={downloadPdf} target="_blank" rel="noreferrer">
              DOWNLOAD PDF{" "}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.083"
                  height="17.083"
                  viewBox="0 0 17.083 17.083"
                >
                  <g
                    id="Group_2599"
                    data-name="Group 2599"
                    transform="translate(-295.25 -1276.25)"
                  >
                    <path
                      id="Path_88207"
                      data-name="Path 88207"
                      d="M9,17h4.675"
                      transform="translate(292.454 1271.688)"
                      fill="#eea346"
                      stroke="#eea346"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_88208"
                      data-name="Path 88208"
                      d="M11.227,6v5.454m0,0,2.727-2.727m-2.727,2.727L8.5,8.727"
                      transform="translate(292.565 1274.117)"
                      fill="#eea346"
                      stroke="#eea346"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_88209"
                      data-name="Path 88209"
                      d="M9.792,17.583A7.792,7.792,0,1,0,2,9.792,7.792,7.792,0,0,0,9.792,17.583Z"
                      transform="translate(294 1275)"
                      fill="none"
                      stroke="#08215c"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
              </span>
            </a>
          </div>
          <div className="plan-content">
            <p>
              Today, Lagos grapples with the tangible realities of climate
              change. Rising sea levels, extreme rainfall, and unprecedented
              heatwaves are not mere predictions but daily challenges that
              threaten our infrastructure, economy, and the very fabric of our
              society. Yet, it is in these challenges that I see immense
              potential for Lagos to rise as a beacon of resilience and
              ingenuity. I am proud to introduce the Lagos Climate Adaptation
              and Resilience Plan (LCARP). This initiative is not just a
              reaction to our current circumstances but a vision for the Lagos
              we aspire to build-a city that leads Africa’s response to climate
              change and sets an example for urban resilience worldwide.
            </p>
            <div className="title">View Project Repository</div>
            <br />
            <div className="btn-grp">
              <a
                href={wasteToEnergyPdf}
                target="_blank"
                rel="noreferrer"
                className="pdf-link"
              >
                <button className="round-btn">WASTE TO ENERGY</button>
              </a>
              <a
                href={wasteWaterPdf}
                target="_blank"
                rel="noreferrer"
                className="pdf-link"
              >
                <button className="round-btn">WASTEWATER TREATMENT</button>
              </a>
              <NavLink to="/Project">Full Project Archive &gt;</NavLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResiliencePlan;
